import { Box, Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { FC, useCallback } from "react";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import api, { STATUS_CODE } from "src/framework/providers/api";
import { Projeto } from "../../types";
import { notifierStore } from "src/framework/store/NotifierStore";

interface ModalCancelamentoEspecialParams {
    open: boolean;
    closeModal: () => void;
    projeto?: Projeto;
    onSuccess: ()=>void;
}

export const ModalCancelamentoEspecial: FC<ModalCancelamentoEspecialParams> = ({ onSuccess, open, closeModal, projeto }) => {
    const onConfirm = useCallback(async () => {
        if (!projeto?.codigo_venda) return;

        const result = await api.post({
            url: "/vendas/pedidos/cancelamento_especial",
            data: { codigo_venda: projeto.codigo_venda }
        })

        if (result.statusCode === STATUS_CODE.OK) {
            closeModal();

            notifierStore.setNotifier({
                title: "Sucesso",
                content: result.data.message || "Cancelamento efetuado com sucesso.",
                onClose: () => {
                    notifierStore.setOpen(false);
                    onSuccess();
                },
                timeOut: 4000,
                onFinishTimeout: () => {
                    notifierStore.setOpen(false);
                    onSuccess();
                }
            })
            notifierStore.setOpen(true);
        }
    }, [closeModal, onSuccess, projeto?.codigo_venda])

    return (
        <Dialog
            open={open}
            onClose={closeModal}
            maxWidth='md'
        >
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid container size={12}>
                        <Grid size={12}>
                            <Box component={"h2"}>Atenção!</Box>
                            <Box component={"span"}><strong>Cancelamento Especial</strong> do projeto - {projeto?.codigo_venda}</Box>
                            <Box component={"p"}>Ao cancelar o projeto, não será mais possível realizar nenhuma <br/>ação sobre ele</Box>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <FlatButton
                    color="inherit"
                    variant="contained"
                    disableElevation
                    text="Fechar"
                    onClick={closeModal}
                />
                <FlatButton
                    color="primary"
                    variant="contained"
                    disableElevation
                    text="Confirmar"
                    onClick={onConfirm}
                />
            </DialogActions>
        </Dialog>
    )
}

